export default "__VITE_ASSET__CSs6qXe3__"